import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import withSpellcheck from "../../../../form-inputs/shared/spell-check";

import { Input, InputList } from "../../../../form-inputs/inputs";

import { EMPTY_USE } from "../lib/constants";

const SpellCheckInputList = withSpellcheck(InputList);

class Use extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.data,
        };
    }

    updateField = (key, value) => {
        this.setState({
            [key]: value,
        });

        this.props.updateOnChange({
            ...this.state,
            [key]: value,
        });
    };

    removeItem = () => {
        this.props.removeItem("uses", this.props.id);
    };

    render() {
        return (
            <div className="drug-item">
                <Input
                    label="Use"
                    name="text"
                    id={`text_${this.state.key}`}
                    value={this.state.text}
                    updateOnChange={this.updateField}
                />
                <SpellCheckInputList
                    label="Use List"
                    name="bullets"
                    id={`bullets_${this.state.key}`}
                    defaultValue={this.state.bullets}
                    updateOnChange={this.updateField}
                    validation={{ type: "StringList" }}
                />
                <div
                    className="close"
                    onClick={this.removeItem}
                >
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            </div>
        );
    }
}

const Uses = (props) => {
    const addNew = () => {
        props.addItem("uses", { ...EMPTY_USE });
    };
    const updateUses = (value) => {
        props.updateOnChange("uses", value);
    };
    const useList = props.data.map((use, index) => {
        return (
            <Use
                key={use.key}
                id={use.key}
                data={use}
                removeItem={props.removeItem}
                updateOnChange={updateUses}
            />
        );
    });

    return (
        <div>
            <h3>Uses</h3>
            {useList}
            <button
                className="button -primary -small"
                onClick={addNew}
            >
                <FontAwesomeIcon icon={faPlus} /> Use
            </button>
        </div>
    );
};

export default Uses;
